import { VerifyCredentialsForm } from '@account_module/components/onboarding/MegaphoneVerifyCredentialsForm';
import { CustomizeImportList } from '@account_module/components/onboarding/MegaphoneCustomizeImportList';
import { DuplicateShowsList } from '@account_module/components/onboarding/MegaphoneDuplicateShowsList';
import { SuccessScreen } from '@account_module/components/onboarding/MegaphoneSuccessScreen';

import { MEGAPHONE_ONBOARDING_STEP_KEYS } from '@account_module/constants/onBoardingKeys';
import { useMegaphoneOnboardContext } from '@account_module/context/MegaphoneOnboardContext';

const VerifyCredentialsStep = (): JSX.Element => {
  const { setIsSidebarVisible, setCurrentStep } = useMegaphoneOnboardContext();

  const handleNextStep = () => {
    setIsSidebarVisible(false);
    setCurrentStep(MEGAPHONE_ONBOARDING_STEP_KEYS.CUSTOMIZE_IMPORT);
  };

  return <VerifyCredentialsForm onSuccess={handleNextStep} />;
};

const CustomizeImportStep = (): JSX.Element => {
  const { setCurrentStep } = useMegaphoneOnboardContext();

  const handleSuccess = () => setCurrentStep(MEGAPHONE_ONBOARDING_STEP_KEYS.HANDLE_DUPLICATE);
  const handleGoBack = () => setCurrentStep(MEGAPHONE_ONBOARDING_STEP_KEYS.VERIFY_CREDENTIALS);

  return <CustomizeImportList onSuccess={handleSuccess} onGoBack={handleGoBack} />;
};

const HandleDuplicatesStep = (): JSX.Element => {
  const { setCurrentStep } = useMegaphoneOnboardContext();

  const handleSuccess = () => setCurrentStep(MEGAPHONE_ONBOARDING_STEP_KEYS.SUCCESS);
  const hadleGoBack = () => setCurrentStep(MEGAPHONE_ONBOARDING_STEP_KEYS.CUSTOMIZE_IMPORT);

  return <DuplicateShowsList onSuccess={handleSuccess} onGoBack={hadleGoBack} />;
};

const SuccessScreenStep = (): JSX.Element => {
  return <SuccessScreen />;
};

const WIZARD_STEPS = {
  [MEGAPHONE_ONBOARDING_STEP_KEYS.VERIFY_CREDENTIALS]: <VerifyCredentialsStep />,
  [MEGAPHONE_ONBOARDING_STEP_KEYS.CUSTOMIZE_IMPORT]: <CustomizeImportStep />,
  [MEGAPHONE_ONBOARDING_STEP_KEYS.HANDLE_DUPLICATE]: <HandleDuplicatesStep />,
  [MEGAPHONE_ONBOARDING_STEP_KEYS.SUCCESS]: <SuccessScreenStep />,
};

export const OnboardWizard = () => {
  const { currentStep } = useMegaphoneOnboardContext();

  return WIZARD_STEPS[currentStep];
};
